<template>
  <div class="row">
    <div class="col-8">
      <breadcrumb :page="page" />
    </div>

    <div class="col-4 text-right mt-4">
      <button
        id="btnFA"
        class="btn btn-action btn-green pt-1"
        @click="$router.go(-1)"
      >
        <i class="fas fa-arrow-circle-left pr-1" />
        Regresar
      </button>
    </div>

    <div class="col-12">
      <div class="tag-badge-info">
        <span class="tag-badge-title-info pb-2 pl-3">
          {{ page.sections[0] }}
        </span>
      </div>
    </div>

    <div class="col-12">
      <DocumentManager
        :id="peiId"
        :methods="methods"
        :menu-actions="menuItems"
        :allowed-files="allowedFiles"
        :required-document-types="requiredDocumentTypes"
        :document-code-type="documentCodeType"
      />
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import DocumentManager from '@/components/common/documents/Documents';
import store from '@/store/index';
import documentTypes from '@/utils/constants/documentTypes.js';

export default {
  name: 'Documents',
  components: {
    breadcrumb,
    DocumentManager,
  },

  data() {
    return {
      peiId: store.getters.SelectedPei,
      page: {
        icon: 'fas fa-user-edit',
        title: 'PEI: Documentos',
        routes: ['Inicio', 'PEI', 'Anejar Documentos', 'PEI'],
        sections: ['I. Documentos del PEI'],
      },
      methods: {
        fetch: `api/pei/attachments/${store.getters.SelectedPei}`,
        upload: `api/pei/uploaddocument`,
        update: `api/pei/updatedocument`,
        delete: `/api/pei/deletedocument?id=`,
      },
      menuItems: [
        {
          iconClass: 'fas text-green fa-file-alt mr-1',
          method: 'downloadFile',
          text: 'Descargar',
        },
        {
          iconClass: 'fas text-green fa-pencil-alt mr-1',
          method: 'editFile',
          text: 'Editar',
          hidden: [documentTypes.LocationRejectedDocument],
        },
        {
          iconClass: 'fas text-red fa-times-circle mr-1',
          method: 'showConfirmationDelete',
          text: 'Eliminar',
          hidden: [
            documentTypes.MinuteControversy,
            documentTypes.MinutaResolucionControversia,
            documentTypes.LocationRejectedDocument,
          ],
          dataAttributes: {
            'data-toggle': 'modal',
            'data-target': '#popup',
          },
        },
      ],
      documentCodeType: 'PeiGeneralDocumentType',
      allowedFiles: '.pdf',
      requiredDocumentTypes: [],
    };
  },
  methods: {},
};
</script>
